import { Component, OnInit, ViewEncapsulation, ViewChild, OnDestroy, ChangeDetectionStrategy, TemplateRef, ElementRef, ChangeDetectorRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
// import { OrderService } from '../../services/order.service';
import { takeUntil } from 'rxjs/operators';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { 
	StripeElements, 
	StripeElementsOptions,
	CustomFontSource,
	StripeCardExpiryElement,
	StripeCardCvcElement,
	StripeCardElement, 
	StripeCardNumberElement, 
	StripeCardElementOptions,
	PaymentIntent } from "@stripe/stripe-js";
// import { StripeCardExpiryComponent, StripeCardNumberComponent, StripeElementsService } from 'ngx-stripe';
// import { StripeService } from 'ngx-stripe';
import { HttpClient } from '@angular/common/http';
import { keys, trimEnd } from 'lodash-es';
import { MatDialog } from '@angular/material/dialog';
import { TermsConditionsDialogComponent } from '../../dialog/terms-conditions/terms-conditions-dialog/terms-conditions-dialog.component';
import * as _ from 'lodash-es';
// import { StripeConnectService } from '../../services/stripe-connect.service';
// import { FormDisplayService } from '../../services/form-display.service';
import { ProcessOrderDialogComponent } from '../../dialog/process-order-dialog/process-order-dialog.component';
import { CasualHireFormService } from '../../casual-hire-form.service';
import { environment } from 'projects/casual-hire-form/src/environments/environment';
import { StripeConnectService } from '@gwc/services/stripe-connect.service';
import { F3DatePipe } from '@f3/pipes/f3-date.pipe';
import { DateHelperService } from '@f3/services/date-helper.service';
import { GwcApiCreditsService } from '@gwc/datasources/gwc-api/credits.service';
import { MatButton } from '@angular/material/button';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { MatInput } from '@angular/material/input';
import { MatFormField } from '@angular/material/form-field';
import { NgClass } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'gwc-frontend-details-payment',
    templateUrl: './details-payment.component.html',
    styleUrls: ['./details-payment.component.scss'],
    providers: [F3DatePipe],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        ReactiveFormsModule,
        MatFormField,
        MatInput,
        NgClass,
        FaIconComponent,
        MatButton,
        MatProgressSpinner
    ]
})
export class HireFormDetailsPaymentComponent implements OnInit, OnDestroy {


	// @Public Properties
	public detailsPaymentForm: UntypedFormGroup | null = null;

	public showErrors = <boolean>false;

	public stripeFields: any = null;

	public creditCheckStatus: boolean | null = null

	public creditCheckLoading: boolean = false;

	public stripeFieldsValid: { stripeCardNumber: boolean, stripeCardExpiry: boolean, stripeCardCvc: boolean } = {
		stripeCardNumber: <boolean>false,
		stripeCardExpiry: <boolean>false,
		stripeCardCvc: <boolean>false
	}

	public faCheckCircle = faCheckCircle

	public qualificationImage: any = null;

	// @Private Properties
	private _unsubscribeAll: Subject<any> = new Subject

	private _orderData: any;

	private _formInitialized = false;


	/**
	 * Construcotr
	 */
	constructor(
		private _matDialog: MatDialog,
		private _formBuilder: UntypedFormBuilder,
		private _stripeConnectService: StripeConnectService,
		private _casualHireFormService: CasualHireFormService,
		private _f3Date: F3DatePipe,
		private _gwcApiCreditsService: GwcApiCreditsService,
		private _changeDetectorRef: ChangeDetectorRef,
		private _dateHelper: DateHelperService
	) {  }

	
	//--------------------------------------------------------------------------------
	// @Lifecycle Hooks
	//--------------------------------------------------------------------------------

	/**
	 * On Init
	 */
	ngOnInit(): void {

		//
		if(window.localStorage.getItem('qualification_image')) {
			this.qualificationImage = JSON.parse(<string>window.localStorage.getItem('qualification_image'));
		}


		this._casualHireFormService.orderData$.pipe(
			takeUntil(this._unsubscribeAll)
		).subscribe({
			next: (orderData) => {
				const initializeForm = !this._formInitialized;
				this._orderData = orderData;

				if (initializeForm) {
					this._initForm(orderData).then(() => {
						this._formInitialized = true;

						this.detailsPaymentForm!.valueChanges.subscribe({
							next: (change) => {
								this._casualHireFormService.addToOrderData('details_payment', change, this.detailsPaymentForm?.valid as boolean && this._creditCardValid())
							}
						})

						this.detailsPaymentForm!.get('creditCard')?.get('name')?.valueChanges.subscribe(
							() => {
								this.showErrors = true;
							}
						)

						let key = environment.stripe['CASUAL_HIRE']['publishableKey'] as string

						if (orderData.institution.institution_type === 'OTHER_TERTIARY') {
							key = environment.stripe['OTHER_TERTIARY']['publishableKey'] as string
						}

						this._stripeConnectService.setKey(key);

						this._initStripeFields().then(() => {
							this._casualHireFormService.stripeFieldsFeed(this._shareStripeFields.bind(this));
						});

					});
				} else {
					this._changeDetectorRef.markForCheck();
				}
			}
		});



		
	}


	ngOnDestroy(): void {
		this._unsubscribeAll.next(null)
		this._unsubscribeAll.complete()
	}


	//************************************************************************
	// @Getters and Setters
	//************************************************************************

	get agreementKeys() {
		return keys( (this.detailsPaymentForm?.get('agreements') as UntypedFormGroup).controls)
	}


	//--------------------------------------------------------------------------------
	// @Public Methods
	//--------------------------------------------------------------------------------
	
	/**
	 * 
	*/
	public getAgreementText(key: string) {
		return this.detailsPaymentForm?.get('agreements')?.get(key)?.get('agreementText')?.value;
	}

	/**
	 * is agreement true
	 */
	public isAgreementTrue(key: string) {
		const isTrue = this.detailsPaymentForm?.get('agreements')?.get(key)?.get('agreed')?.value
		return isTrue;
	}

	/**
	 * Toggle the agreement selection
	 */
	public toggleAgreement(key: string) {
		const control = this.detailsPaymentForm?.get('agreements')?.get(key)?.get('agreed');
		control?.setValue( control.value ? false : true )
	}

	/**
	 * Open the terms and conditions window
	 */
	public termsAndConditionsClicked(e: Event) {
		e.stopPropagation();
		
		const dialogRef = this._matDialog.open(TermsConditionsDialogComponent)
	}

	/**
	 * Agreement is invalid
	 */
	public agreementIsInvalid(agreementKey: string) {
		return !this.isAgreementTrue(agreementKey) && this.showErrors
	}

	public isFileNotUploaded() {
		return this.showErrors && !(this.qualificationImage ? true : false);
	}

    /**
     * File selected from file input
     * @param event 
     */
	 public onFileSelected(event: Event) {
		const input = event.target as HTMLInputElement;
		const files = input.files;

		if (files && files.length > 0) {
			const file = files[0];

			const reader = new FileReader();
			reader.readAsDataURL(file)

			reader.onload = () => {

				//put the image in the local storage
				if(reader.result) {
					if(window.localStorage.getItem('qualification_image')) {
						window.localStorage.removeItem('qualification_image');
					}

					const payload = {
						file: {name: file.name, size: file.size, type: file.type},
						content: reader.result
					}

					console.log(payload)

					window.localStorage.setItem('qualification_image', JSON.stringify(payload))
					this.qualificationImage = payload;
					this.detailsPaymentForm?.get('qualification')?.get('qualImage')?.setValue(payload);
					this.showErrors = true;
					// Update template
					this._changeDetectorRef.markForCheck()
				}

			}
		}

    }

    /**
     * Function when the image is loaded into the cropper
     * @param image 
     */
    public imageLoaded(image: any) {

    }

	/**
	 * 
	 */
	public checkCreditCode() {

		this.creditCheckStatus = null;
		this.creditCheckLoading = true;

		this._gwcApiCreditsService.check(this.detailsPaymentForm?.get('credit')?.value.credit_code).subscribe({
			next: (result: any) => {

				if(result.credit_code && result.amount) {
					this.detailsPaymentForm?.get('credit')?.get('checked')?.patchValue(true)
					this.detailsPaymentForm?.get('credit')?.get('amount')?.patchValue(result.amount)

					this.creditCheckStatus = true;

					let temp = _.cloneDeep(this._orderData.regalia);
					temp.push({
						institution_qualification_regalia_id: 'credit',
						institution_qualification_id: '',
						regalia_id: '',
						price: result.amount * -1,
						data: {
							credit_code: result.credit_code
						}
					})
					this._casualHireFormService.addToOrderData('regalia', temp, this.detailsPaymentForm?.valid as boolean)

					// this._changeDetectorRef.markForCheck()
				}

				this.creditCheckLoading = false;
			},
			error: (err) => {
				this.creditCheckStatus = false;
				this.creditCheckLoading = false;

				// this._changeDetectorRef.markForCheck()
			}
		})

	}

	
	//--------------------------------------------------------------------------------
	// @Private Methods
	//--------------------------------------------------------------------------------

	private _initForm(orderData: any): Promise<boolean> {

		return new Promise((resolve, reject) => {
			this.detailsPaymentForm = this._formBuilder.group({
				details: this._formBuilder.group({
					firstName: [orderData?.details_payment.details?.firstName || null, Validators.required],
					surname: [orderData?.details_payment.details?.surname || null, Validators.required],
					email: [orderData?.details_payment.details?.email || null, [Validators.required, Validators.email]],
					mobilePhone: [orderData?.details_payment.details?.mobilePhone || null, Validators.required],
					// studentId: [orderData ?.details_payment.details?.studentId || null, Validators.required]
				}),
				address: this._formBuilder.group({
					address: [orderData?.details_payment.address?.address || null],
					address2: [orderData?.details_payment.address?.address2 || null],
					city: [orderData?.details_payment.address?.city || null],
					postcode: [orderData?.details_payment.address?.postcode || null],
					country: [orderData?.details_payment.address?.country || null]
				}),	
				credit: this._formBuilder.group({
					credit_code: [null],
					amount: [ null ],
					checked: [ false ]
				}),
				creditCard: this._formBuilder.group({
					name: [orderData?.details_payment.creditCard?.name, Validators.required],
				}),
				agreements: this._formBuilder.group({
					agreementCollection: this._formBuilder.group({
						agreementText: [this._initCollectionAgreementText()],
						agreed: [false, Validators.requiredTrue]
					}),
					agreementLateFee: this._formBuilder.group({
						agreementText: ['A $50 security hold will be applied to the card used to purchase the regalia hire with GWC Regalia Hire.  If we cannot secure this amount AT CHECK-IN, the student will not be able to collect their regalia.  This security hold CANNOT be paid in cash.  The security hold will be released if the regalia is return within the stipulate timeframe on the order or returned without damage.  NB: Additional charges for lost or damage regalia will apply. <br><br>The return, late return fee, damage or loss is the responsibility of the student whose name is on the hire agreement with GWC Regalia Hire.'],
						agreed: [false, Validators.requiredTrue]
					}),
					agreementTerms: this._formBuilder.group({
						agreed: [false, Validators.requiredTrue]
					}),
				}),
				qualification: this._formBuilder.group({
					qualImage: [null, Validators.required],
				}),
					
			})

			resolve(true)
		})

	}

	/**
	 * INit the collection agreement text
	 */
	private _initCollectionAgreementText() {

		console.log(this._orderData)
		

		const pickUp = this._dateHelper.formatToNZReadable(this._orderData.collection.pickup);
		const dropOff = this._dateHelper.formatToNZReadable(this._orderData.collection.dropoff)
		
		return `You acknowledge and agree that the pick up date and time for your regalia is from <span class="font-bold">${pickUp}</span> between the hours of 9:30am and 2:30pm and will drop off the regalia by 2pm on <span class="font-bold">${dropOff}</span>.`

	}


	private _initStripeFields() {

		const elementOptions = <StripeElementsOptions>{
			fonts: [
				{
					cssSrc: 'https://fonts.googleapis.com/css2?family=Mukta:wght@300&display=swap'	
				}
			],
			locale: 'en'
		} 

		const cardOptions: StripeCardElementOptions = {
			classes: {
				base: 'stripe-element',
				invalid: 'stripe-element-invalid'
			},
			style: {
				base: {
					iconColor: '#666EE8',
					color: '#000000',
					fontWeight: '300',
					fontFamily: 'Mukta',
					fontSize: '16px',
					'::placeholder': {
						color: '#CFD7E0'
					}
				}
			}
		};

		return new Promise((resolve, reject) => {

			this._stripeConnectService.elements(elementOptions)
				.subscribe({
					next: (elements) => {

						if(!this.stripeFields && elements) {
							
							this.stripeFields = {
								stripeCardNumber: elements.create('cardNumber', cardOptions),
								stripeCardExpiry: elements.create('cardExpiry', cardOptions),
								stripeCardCvc: elements.create('cardCvc', cardOptions)
							}

							this.stripeFields.stripeCardNumber.mount('#stripe-card-number');
							this.stripeFields.stripeCardExpiry.mount('#stripe-card-expiry');
							this.stripeFields.stripeCardCvc.mount('#stripe-card-cvc');

							_.forEach(this.stripeFields, (value, key) => {
								this.stripeFields[key].on('change', (e: any) => {
									_.set(this.stripeFieldsValid, key, !e.error && e.complete ? true : false)

									this._emitFormValid();
								})
							})
						}

					},
					complete: () => {

						resolve(true)

					}

				})
			
		})

	}


	private _emitFormValid() {
		this._casualHireFormService.updateStepValidity(this.detailsPaymentForm?.valid as boolean && this._creditCardValid())
		// Check that the form is valid here as this is the last step
		this.detailsPaymentForm?.markAllAsTouched();
	}
	

	private _creditCardValid(): boolean {
		return this.stripeFieldsValid.stripeCardNumber && this.stripeFieldsValid.stripeCardExpiry && this.stripeFieldsValid.stripeCardCvc
	}


	private _shareStripeFields() {
		return this.stripeFields;
	}

}
